import * as React from 'react';
import {connect} from "react-redux";
import {User} from "../../models/User";
import {ApplicationState} from "../../store";
import {UserList} from '../components/UserList';
import {ColumnData} from '../../models/ColumnData';
import {AppStore} from "../../desktop";
import {actionUserFetchAll, UsersActionTypes} from "../../store/users";
import {Button} from "@material-ui/core";
import {Tab, TabTypes} from "../Tab";
import {TabsService} from "../TabsService";
import AddIcon from "@material-ui/icons/AddCircleOutlineRounded";
import { actionUserDelete, actionDeleteUsers } from '../../store/users/actions';
import {t} from "../../core/localization";
import {toastr} from 'react-redux-toastr'
import {actionRoleFetchAll} from "../../store/roles";
import {Role} from "../../models/Role";
import {Position} from "../../models/Position";
import {actionPositionFetchAll} from "../../store/positions";

export interface UsersTabProps {
	users: User[]
	roles: Role[]
	positions: Position[]
	tab: Tab
}

export interface UsersTabState {
}

function mapStateToProps(state: ApplicationState) {
	return {
		users: state.users.list,
		roles: state.roles.list,
		positions: state.positions.list,
		tab: state.tabs.active
	};
}

class UsersTab extends React.Component<UsersTabProps, UsersTabState> {

	constructor(props: UsersTabProps) {
		super(props)
	}

	componentWillMount() {
	}

	componentWillReceiveProps(nextProps: UsersTabProps) {
	}

	componentDidMount() {
		this.loadData()
	}

	onOpenClick(user: User){
		TabsService.createTab('User: ' + user.firstName, TabTypes.USERS_NEW, user)
	}

	onCopyClick(user: User){
		TabsService.createTab('User: ' + user.firstName, TabTypes.USERS_NEW, { ...user, id: null })
	}

	onDeleteClick(user: User){
		actionUserDelete(user);
	}

	onActionDeleteClick(users: User[]){
		actionDeleteUsers(users);
	}

	onNewClick() {
		TabsService.createTab('User new', TabTypes.USERS_NEW, new User())
	}

	render(): React.ReactNode {

		const {users} = this.props;

		var rolesMap = this.props.roles.reduce((map: any, role: Role) => {
			map[role.id] = role.name;
			return map;
		}, {});

		var positionsMap = this.props.positions.reduce((map: any, position: Position) => {
			map[position.id] = position.title;
			return map;
		}, {});

		const columns = [
			new ColumnData(t.FirstName, "firstName"),
			new ColumnData(t.LastName, "lastName"),
			new ColumnData("Email", "email"),
			new ColumnData(t.Position, "positionId", positionsMap),
			new ColumnData(t.Role, "roleId", rolesMap)
		];

		return (
			<div style={{padding: '10px'}}>
				<div style={{marginBottom: '10px'}}><Button onClick={this.onNewClick} color="primary" style={{}}><AddIcon />{t.CreateNewUser}</Button></div>
				<UserList
					columns={columns}
					items={users}
					title={t.Users}
					onOpenClick={(user: User) => this.onOpenClick(user)}
					onCopyClick={(user: User) => this.onCopyClick(user)}
					onDeleteClick={(user: User) => this.onDeleteClick(user)}
					onActionDeleteClick={(users: User[]) => this.onActionDeleteClick(users)}
					tab={this.props.tab}
				/>
			</div>
		);
	}

	private loadData() {
		actionUserFetchAll()
		actionRoleFetchAll()
		actionPositionFetchAll()
	}
}

export default connect(mapStateToProps)(UsersTab);
